import axios from 'axios';
import { createAsyncThunk } from 'app/store/utils';
import { Credit, FetchCreditsResponse, Link } from 'types/api.types';
import { apiErrorHandler, buildQueryUrl } from 'app/utils/utils';
import { FetchContributionsResponse } from 'types/contribution';
import { getCreditsListLink } from './selectors';
import { addAlertAction } from '../Alerts/slice';

export const fetchCreditsListEffect = createAsyncThunk(
  'contributions/fetchCreditList',
  async (data: { next?: Link } | undefined = {}, { dispatch, getState }) => {
    const isNext = Boolean(data.next);
    const state = getState();
    const fetchCreditsLink = getCreditsListLink(state);
    try {
      if (!fetchCreditsLink) {
        throw new Error('Fetch Credits list link not found');
      }
      const response = await axios.get<FetchCreditsResponse>(
        data?.next?.href ||
          buildQueryUrl(fetchCreditsLink?.href, {
            sortBy: 'updatedAt',
            sortOrder: 'desc',
          }),
        {
          withCredentials: true,
        }
      );
      const { items, _links } = response.data.response.myContributions;
      return {
        items,
        _links,
        isNext,
      };
    } catch (e: any) {
      dispatch(addAlertAction({ message: apiErrorHandler(e.response) }));
      throw e;
    }
  }
);

export const fetchCreditsDetailsEffect = createAsyncThunk(
  'contributions/fetchCreditDetails',
  async (credit: Credit) => {
    if (!credit?._links.getDetails) {
      throw new Error('get Credits details link not found');
    }
    const { data } = await axios.get<FetchContributionsResponse>(
      credit._links.getDetails.href,
      {
        withCredentials: true,
      }
    );
    return {
      contributions: data.response.contributions,
      songGuid: credit.guid,
    };
  }
);
